import { render, staticRenderFns } from "./itemBadRecord.vue?vue&type=template&id=66536c2d&scoped=true"
import script from "./itemBadRecord.vue?vue&type=script&lang=js"
export * from "./itemBadRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66536c2d",
  null
  
)

export default component.exports